import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { setAgentUpdatePassword} from './axios';
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./AgentSignup.css";
import Spinner from 'react-bootstrap/Spinner';

//const regularExpression = RegExp(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/)
const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);


export default function AgentResetPassword() {

  const { id } = useParams();
  const currentemailID = atob(id);
    const [sussessRegister, setSussessRegister] = useState(false);
    const [PasswordMatchcheck, setPasswordMatchcheck] = useState(false);
    const [btnloader, setbtnloader] = useState(0);
    const {
        register,
        handleSubmit, watch,
        formState: { errors },
      } = useForm({
        mode: "onChange",
      });
    
      // Start On Change Status Data Show
      const onChange = (e) => {
     };

     const password = useRef({});
        password.current = watch("password", "");
     // End On Change Status Data Show
     // On Submit User List
      const onSubmit = (data) => {
        let subData = true;
        setbtnloader(1);

      
    setTimeout(() => {
        if (subData) {
            setSussessRegister(false);
           
           let password = data.password;
           let email = currentemailID;
        setAgentUpdatePassword(email, password).then(
            (data) => {
                //console.log(data);
                setSussessRegister(true);
              
                var base_url = window.location.origin;
                window.location.href = base_url+"/agentresetcompleted";
                setbtnloader(0);
            },
            (error) => {
    
            }
        );
           
        }

      }, 3000);
      }
    



    return (
      <div id="login">
      <aside id="agentlogin" style={{ width: '25%'}}>
          <figure> <a href="/"><img src="images/logo/seyLogo.png" alt="Holiday Seychelles" class="logo_sticky" /></a> </figure>
          {/* <p style={{fontSize: '20px', fontWeight: 600}}>Forgot Password</p> */}
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          {/* {sussessRegister && (
                    <div class="alert alert-success" role="alert">
                    We have sent an email on your registererd mail address that will help to reset password for your account.
                    </div>
                     )} */}
                     
            <div class="form-group" style={{marginBottom: '1rem'}}>
              <label>New Password</label>
              <input
                                  type="password"
                                  className={`form-control ${
                                    errors.password && "Err"
                                  }`}
                                  {...register("password", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 20,
                                  })}
                                  id="password"
                                  name="password"
                                  placeholder="Enter New Password"
                                />
                                  <i className="icon_lock_alt"></i>  
                                {errors.password &&
                                  errors.password.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Password
                                    </span>
                                  )}
                                {errors.password &&
                                  errors.password.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Password must be at least 6 characters
                                      long!
                                    </span>
                                  )}
                                {errors.password &&
                                  errors.password.type === "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Password must be at maximum 20 characters
                                      long!
                                    </span>
                                  )}
                                </div>

                                <div class="form-group" style={{marginBottom: '1rem'}}>
                              <label> Confirm Password</label>
                                     <input
                                  type="password"
                                  className={`form-control ${
                                    errors.confirmpassword && "Err"
                                  }`}
                                  {...register("confirmpassword", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 20,
                                    validate: value =>
                                    value === password.current || "The passwords do not match",
                                  })}
                                  id="confirmpassword"
                                  name="confirmpassword"
                                  placeholder="Enter  Confirm Password"
                                />
                                   <i className="icon_lock_alt"></i>  
                                {errors.confirmpassword && <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>{errors.confirmpassword.message} </span>}
                                
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your  Confirm Password
                                    </span>
                                  )}
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Confirm Password must be at least 6 characters
                                      long!
                                    </span>
                                  )}
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Confirm Password must be at maximum 20 characters
                                      long!
                                    </span>
                                  )}
                                </div>
            
            <div class="clearfix add_bottom_30">
              <div class="checkboxes float-left">
              </div>
             
            </div>
            <button type="submit" className="btn_1 rounded full-width">Submit  &nbsp;{btnloader === 1 ? (<Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          visually-hidden="true"
        />) : ""}</button>
            
            {/* <div class="text-center add_top_10"><strong><Link to='/agentsignup'>SignUp </Link></strong></div> */}
          </form>
        </aside>
        </div> 
        );
   
}